import * as EventEmitter from 'events';
import { Node } from './node';
import { Page } from './page';

function getModalNodes(node: Node) {
  let nodes: any = [];
  const prototype = node.getPrototype();
  if (prototype && prototype.isModal()) {
    nodes.push(node);
  }
  const children = node.getChildren();
  if (children) {
    children.forEach((child) => {
      nodes = nodes.concat(getModalNodes(child));
    });
  }
  return nodes;
}

export default class ModalNodesManager {
  public willDestroy: any;

  private page: Page;
  private modalNodes: [Node];
  private nodeRemoveEvents: any;
  private emitter: EventEmitter;

  constructor(page: Page) {
    this.page = page;
    this.emitter = new EventEmitter();
    this.nodeRemoveEvents = {};
    this.setNodes();
    this.hideModalNodes();
    this.willDestroy = [
      page.onNodeCreate((node) => this.addNode(node)),
      page.onNodeDestroy((node) => this.removeNode(node)),
    ];
  }

  public getModalNodes() {
    return this.modalNodes;
  }

  public getVisibleModalNode() {
    const visibleNode = this.modalNodes
      ? this.modalNodes.find((node: Node) => {
          return !!node.getStatus('visibility');
        })
      : null;
    return visibleNode;
  }

  public hideModalNodes() {
    if (this.modalNodes) {
      this.modalNodes.forEach((node: Node) => {
        node.setStatus('visibility', false);
      });
    }
  }

  public setVisible(node: Node) {
    this.hideModalNodes();
    node.setStatus('visibility', true);
  }

  public setInvisible(node: Node) {
    node.setStatus('visibility', false);
  }

  public onVisibleChange(func: () => any) {
    this.emitter.on('visibleChange', func);
    return () => {
      this.emitter.removeListener('visibleChange', func);
    };
  }

  public onModalNodesChange(func: () => any) {
    this.emitter.on('modalNodesChange', func);
    return () => {
      this.emitter.removeListener('modalNodesChange', func);
    };
  }

  private addNode(node: Node) {
    const prototype = node.getPrototype();
    if (prototype && prototype.isModal()) {
      this.hideModalNodes();
      this.modalNodes.push(node);
      this.addNodeEvent(node);
      this.emitter.emit('modalNodesChange');
      this.emitter.emit('visibleChange');
    }
  }

  private removeNode(node: Node) {
    const prototype = node.getPrototype();
    if (prototype && prototype.isModal()) {
      const index = this.modalNodes.indexOf(node);
      if (index >= 0) {
        this.modalNodes.splice(index, 1);
      }
      this.removeNodeEvent(node);
      this.emitter.emit('modalNodesChange');
      if (node.getStatus('visibility')) {
        this.emitter.emit('visibleChange');
      }
    }
  }

  private addNodeEvent(node: Node) {
    this.nodeRemoveEvents[node.getId()] =
        node.onStatusChange((status: any, field: any) => {
          if (field === 'visibility') {
            this.emitter.emit('visibleChange');
          }
        });
  }

  private removeNodeEvent(node: Node) {
    if (this.nodeRemoveEvents[node.getId()]) {
      this.nodeRemoveEvents[node.getId()]();
      delete this.nodeRemoveEvents[node.getId()];
    }
  }

  private setNodes() {
    const nodes = getModalNodes(this.page.getRoot());
    this.modalNodes = nodes;
    this.modalNodes.forEach((node: Node) => {
      this.addNodeEvent(node);
    });

    this.emitter.emit('modalNodesChange');
  }
}



// WEBPACK FOOTER //
// ./lib/engine/core/pages/modalNodesManager.ts